import React, { useState } from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { post } from "src/utils/networkUtils";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
const WinnerListTable = () => {
  const location = useLocation();
  const prizeDraw = location.state?.prizes;
  const [loadingIds, setLoadingIds] = useState([]);
  const handleSendNotification = async (userId) => {
    setLoadingIds((prev) => [...prev, userId]);

    try {
      const body = {
        subject: "Prize Draw Winner",
        body: `Congratulations! You won the prize draw.`,
        specificUserIds: userId,
        status: 1,
        auditory: "userids",
        publishAt: moment().format(dateFormat),
      };
      await post(`/admin/inbox-messages`, body);
    } catch (error) {
      console.error("Error sending notification:", error);
    } finally {
      setLoadingIds((prev) => prev.filter((id) => id !== userId));
    }
  };

  return (
    <>
      <h2>Prize Draw Winners</h2>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Prize Name</TableCell>
              <TableCell>Winner Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Number of Entries</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {prizeDraw?.prizes?.map((row, index) => {
              if (row !== null && row !== undefined && row?.userId) {
                const isLoading = loadingIds.includes(row.userId);
                return (
                  <TableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {row.Title}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.username}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.Email}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.amount}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        key={row.userId}
                        onClick={() => handleSendNotification(row.userId)}
                        disabled={isLoading}
                        sx={{
                          border: "1px solid #1976d2",
                          borderRadius: "8px",
                          color: "#1976d2",
                          width: 40,
                          height: 40,
                          position: "relative",
                        }}
                      >
                        {isLoading ? (
                          <CircularProgress
                            size={20}
                            sx={{ color: "#1976d2" }}
                          />
                        ) : (
                          <MailOutlineIcon />
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              } else {
                return <></>;
              }
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default WinnerListTable;
